'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'sun-bright';
var width = 512;
var height = 512;
var aliases = ["sun-alt"];
var unicode = 'e28f';
var svgPathData = 'M240 512l0-104 32 0 0 104-32 0zm0-408l0-104 32 0 0 104-32 0zM425.7 448.3L414.4 437c-40.5-40.5-61.3-61.3-62.2-62.2l22.6-22.6c.9 .9 21.7 21.7 62.2 62.2l11.3 11.3-22.6 22.6zM137.2 159.8c-.9-.9-21.7-21.7-62.2-62.2L63.7 86.3 86.3 63.7c.9 .9 21.7 21.7 62.2 62.2l11.3 11.3-22.6 22.6zM496 272l-88 0 0-32 104 0 0 32-16 0zM88 272l-88 0 0-32 104 0 0 32-16 0zM448.3 86.3c-.9 .9-21.7 21.7-62.2 62.2l-11.3 11.3-22.6-22.6c.9-.9 21.7-21.7 62.2-62.2l11.3-11.3 22.6 22.6zM159.8 374.8c-.9 .9-21.7 21.7-62.2 62.2l-11.3 11.3-22.6-22.6c.9-.9 21.7-21.7 62.2-62.2l11.3-11.3 22.6 22.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunBright = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;